exports.components = {
  "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js": () => import("./../../../gatsby-theme-landing-page/src/pages/{ContentfulLandingPage.slug}.js" /* webpackChunkName: "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js" */)
}

